<template>
    <div :class='{ light: text_color === "#FFFFFF" }' :style='{ backgroundColor: bg_color, color: text_color }'>
        <div class='container'>
            <div class='row offset--md-3'>

                <div class='col--md-6 col--lg-7 gutter--sm-big gutter--md-none justify--center'>
                    <h2 class='bold'>{{ title }}</h2>
                    <div class='vertical--quarter' v-html='dek'></div>
                </div>

                <div class='col--sm-expand col--md-5 col--lg-3 offset--md-1 offset--lg-2 justify--center vertical--sm-1 vertical--md-0'>
                    <a class='cta read-more' :href='url' :style='{ backgroundColor: cta_bg_color }'>
                        {{ cta_text }}
                        <span class='caret--right' aria-hidden='true'>
                            <svg class='svg svg--caret' width='13' height='7' viewBox='0 0 13 7'>
                                <path d='M6.35 6.44L.56.87C.52.83.5.78.5.71.5.59.59.5.72.5.77.5.83.52.87.56L6.5 5.99 12.14.56c.04-.04.09-.06.15-.06.12 0 .22.09.22.21 0 .06-.02.12-.06.16l-5.8 5.57c-.04.04-.09.06-.15.06s-.11-.02-.15-.06z' />
                            </svg>
                        </span>
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'url',
        'title',
        'dek',
        'bg_color',
        'text_color',
        'cta_bg_color',
        'cta_text'
    ]
};
</script>



// WEBPACK FOOTER //
// assets/js/thelist/components/Banner.vue